import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import './index.css';

// import Application from './containers/ApplicationContainer';

import Application from './App';

import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
import { composeWithDevTools } from 'redux-devtools-extension';

import { rootReducer } from './store';
import { chatMessageSaga } from './store/chatmessage/sagas';
import { chatStatusSaga } from './store/chatStatus/sagas';

// export const store = createStore(
//   rootReducer,
//   composeWithDevTools(applyMiddleware(sagaMiddleware))
// );
const composeEnhancers = composeWithDevTools({
  //
});

const sagaMiddleware = createSagaMiddleware();

// sagaMiddleware.run(chatMessageSaga);
// sagaMiddleware.run(chatStatusSaga);

export let store: any;
if (process.env.NODE_ENV === 'development') {
  store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware))
  );
} else {
  store = createStore(rootReducer, applyMiddleware(sagaMiddleware));
}
const generateId = () =>
  Math.random()
    .toString(36)
    .substr(2, 9);

store.subscribe(() => {
  if (!localStorage.getItem('user_token')) {
    //新規訪問時にhash作成
    localStorage.setItem('user_token', generateId());
    const time = new Date().toLocaleDateString();
    localStorage.setItem('date', time);
  } else if (localStorage.getItem('date')) {
    // 別日ならhash更新
    const time = new Date();
    const localDate = localStorage.getItem('date');
    const date = `${time.getFullYear()}/${time.getMonth() +
      1}/${time.getDate()}`;

    if (localDate !== null) {
      const storageDay = new Date(localDate);
      if (
        time.getFullYear() !== storageDay.getFullYear() ||
        time.getMonth() !== storageDay.getMonth() ||
        time.getDate() !== storageDay.getDate()
      ) {
        localStorage.setItem('user_token', generateId());
        localStorage.setItem('date', date);
        localStorage.removeItem('chat-message');
      }
    } else {
      localStorage.setItem('user_token', generateId());
      localStorage.setItem('date', date);
      localStorage.removeItem('chat-message');
    }
  }
});

function* rootSaga() {
  yield all([...chatMessageSaga, ...chatStatusSaga]);
}
sagaMiddleware.run(rootSaga);

// sagaMiddleware.run(chatMessageSaga);
// sagaMiddleware.run(chatStatusSaga);

ReactDOM.render(
  <Provider store={store}>
    <Application />
  </Provider>,
  document.getElementById('chatbot-root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
